import app from '../app';
import {
  inputOfferPrice,
  changeUserGeo,
  loadPublishTerms,
  updateOffer,
  needIdentification,
  publishToHiddenBase,
  setLayoutParams,
  changeSavedOffer,
  changeUser,
  changeDictionaryCountryCodes,
  changeDictionaryRegions,
} from '../../../../shared/redux/reducers';
import { shouldLoadPublishTermsAfterOfferUpdate } from '../utils';
import { clone, path, omit, equals, isEmpty } from 'ramda';
import { selectActiveCalltrackingPeriod } from '../../../../shared/selectors/calltracking';
import { getPhone } from '../../../../shared/utils';
import { selectConfigValue } from '../../../../shared/selectors/config';
import { getIsDynamicPricingParametersUpdated } from '../../../../shared/utils/dynamicPricing';

const getPrice = offer => path(['bargainTerms', 'price'], offer);

export function rootScopeWatcherService(
  $rootScope,
  store,
  geoService,
  placingTermsApi,
  $timeout,
  addFormService,
  pubAvailService,
  hiddenBaseService,
  publishTermsService,
  addFormLayoutService,
) {
  'ngInject';

  const state = store.getState();
  const dynamicPricingAttributes = selectConfigValue('dynamicPricingAttributes', state);

  return {
    init: () => {
      /* ВАЖНО: Не нужно здесь отправлять экшены в стор для первого сохранения данных,
          поскольку вотчеры в функции subscribe вызывают свои листенеры первый раз при инициализации. */
    },
    subscribe: () => {
      let isFirstPublishTermsRequest = true;
      let isInitialHiddenBaseCall = true;

      $rootScope.$watch(
        () => $rootScope.ad,
        (offer, prevOffer) => {
          store.dispatch(updateOffer(clone(offer)));

          if (isEmpty(prevOffer) || isEmpty(offer)) {
            // Если один из объектов пуст, нет смысла делать запрос в publish-terms
            return;
          }

          const isExtraFieldsUpdated = getIsDynamicPricingParametersUpdated({
            offer,
            prevOffer,
            dynamicPricingAttributes,
          });
          const shouldLoadPublishTerms = shouldLoadPublishTermsAfterOfferUpdate(offer, prevOffer, isExtraFieldsUpdated);
          const isPriceChanged = getPrice(offer) !== getPrice(prevOffer);

          if (isFirstPublishTermsRequest || shouldLoadPublishTerms) {
            store.dispatch(loadPublishTerms());
          }

          if (isPriceChanged) {
            store.dispatch(inputOfferPrice());
          }

          isFirstPublishTermsRequest = false;
        },
        true,
      );

      $rootScope.$watch(
        () => $rootScope.countryCodes,
        countryCodes => {
          store.dispatch(changeDictionaryCountryCodes(clone(countryCodes)));
        },
        true,
      );

      $rootScope.$watch(
        () => $rootScope.regions,
        regions => {
          store.dispatch(changeDictionaryRegions(clone(regions)));
        },
        true,
      );

      $rootScope.$watch(
        () => $rootScope.savedAd,
        savedOffer => {
          store.dispatch(changeSavedOffer(clone(savedOffer)));
        },
        true,
      );

      $rootScope.$watch(
        () => $rootScope.user,
        user => {
          store.dispatch(changeUser(clone(user)));
          store.dispatch(loadPublishTerms());
        },
        true,
      );

      $rootScope.$watch(
        () => geoService.userGeo,
        userGeo => {
          store.dispatch(changeUserGeo(clone(userGeo)));
        },
        true,
      );

      $rootScope.$watch(
        /* если isAvailable == undefined - запрос доступности публикации еще не начался,
           либо в процессе => идентификация не нужна */
        () => pubAvailService.isAvailable === false,
        isNeedIdentification => {
          store.dispatch(needIdentification(isNeedIdentification));
        },
      );

      $rootScope.$watch(
        () => !!hiddenBaseService.isEnabled(),
        isHiddenBaseEnabled => {
          store.dispatch(publishToHiddenBase(isHiddenBaseEnabled));

          if (isInitialHiddenBaseCall) {
            isInitialHiddenBaseCall = false;
          } else if (!isHiddenBaseEnabled) {
            store.dispatch(loadPublishTerms());
          }
        },
      );

      addFormLayoutService.onIsShortFormChange(({ isShortForm, oldIsShortForm }) => {
        if (isShortForm !== oldIsShortForm) {
          store.dispatch(setLayoutParams({ isShortForm }));
        }
      });

      store.subscribe(() => {
        if (!publishTermsService.isNewPublishTermsEnabled()) {
          return;
        }

        const state = store.getState();
        const {
          calltracking: { isAvailable, isEnabled },
        } = state;

        const calltracking = omit(['selectedPeriod'], placingTermsApi.calltrackingOption);

        let shouldApply = false;

        // Синхронизируем изменения колтрекинга
        if (!equals(calltracking, state.calltracking)) {
          const selectedPeriod = { ...selectActiveCalltrackingPeriod(state) };
          const calltrackingOption = { ...state.calltracking, selectedPeriod };

          placingTermsApi.calltrackingOption = calltrackingOption;
          placingTermsApi.isCalltrackingAvailable = isAvailable;
          placingTermsApi.selectAdditional(calltrackingOption);
          placingTermsApi.isCalltrackingSelected = () => isEnabled;

          if (isEnabled && !addFormService.ad.replacedPhone) {
            const phones = addFormService.ad.phones || [];

            addFormService.ad.replacedPhone = getPhone(phones[0]);
          }

          shouldApply = true;
        }

        if (shouldApply) {
          // Ждем пока закончится текущий digest cycle ангуляра и говорим ему что состояние обновилось
          $timeout(() => {
            $rootScope.$apply();
          });
        }
      });
    },
  };
}

app.factory('ngStoreToReduxMergeService', rootScopeWatcherService);
